import { langTextMap } from '../common/i18n';
import { getSchemeLink, PLATFORM_TYPE } from '../common/scheme';
import { computed } from 'vue-demi';
const { useUser, useI18n, useBehaviour, useToast } = require('@fegobull/webapi').use;
const { runBehaviour } = useBehaviour();
const Toast = useToast();

export default (props, setSelectStatus) => {
    const $t = useI18n(langTextMap, props.language);

    // 表头配置
    const headerConfig = computed(() => {
        return {
            show: props.showHeader,
            column: {
                name: $t('name'),
                trend: $t('trend'),
                increase: $t('increase'),
                wch: $t('wch')
            }
        };
    });

    // 点击跳转
    const itemClick = ($event, stock) => {
        if (props.schemeType) {
            const link = getSchemeLink(props.schemeType, stock, props.platform || PLATFORM_TYPE.MOOMOO);

            link &&
                runBehaviour(
                    null,
                    {
                        type: props.platform === PLATFORM_TYPE.NIUNIU ? 'jump' : 'jumpMM',
                        value: link
                    },
                    $event
                );
        }
    };

    // icon点击跳转
    const iconClick = async ($event, stock, selected) => {
        const { isLogin } = useUser();
        if (!isLogin) {
            return runBehaviour(null, { type: 'login', withQuery: true }, $event);
        }
        await setSelectStatus(stock, selected);
        Toast.msg($t(selected ? 'del_selected_succ' : 'add_selected_succ'));
    };

    return {
        headerConfig,
        itemClick,
        iconClick
    };
};
